import { TicketReceiver } from '../../types/qztray/QzTrayTypes';

export interface TicketReceiverField {
  label: string;
  value: string;
}

/** Presenta únicamente datos resueltos por backend, sin inferir reglas fiscales. */
export const getTicketReceiverFields = (
  receiver?: TicketReceiver | null,
  context: 'SALE' | 'PURCHASE' = 'SALE',
): TicketReceiverField[] => {
  if (!receiver?.name?.trim()) return [];

  const fields: Array<[string, string | null | undefined]> = [
    ['Nombre', receiver.name],
  ];
  const hasSpecificReceiverData = [
    receiver.entityType,
    receiver.documentType,
    receiver.identificationNumber,
    receiver.nrc,
    receiver.otherField,
    receiver.email,
  ].some((value) => Boolean(value?.trim()));

  if (!hasSpecificReceiverData) return [{ label: 'Nombre', value: receiver.name.trim() }];

  const isNaturalPerson = receiver.entityType?.toUpperCase().includes('NATURAL');
  fields.push(
    ['Correo', receiver.email],
    ['Tipo de entidad', receiver.entityType],
    ['NRC', context === 'PURCHASE' || !isNaturalPerson ? receiver.nrc : null],
    ['Tipo de documento', receiver.documentType],
    ['Documento de identificación', receiver.identificationNumber],
    ['Otro', receiver.otherField],
  );

  return fields.flatMap(([label, value]) => {
    const normalized = value?.trim();
    return normalized ? [{ label, value: normalized }] : [];
  });
};
